const HOSTURLOBJECT = window.location
let configURL = {
	http_url:'',
	initveUrl:''
}

if(HOSTURLOBJECT.hostname == 'localhost'){
	//onedex.club
	//onedex.darw.club
   // onedex.pro
	 configURL = {
		  http_url:"https://onedex.club/api",
		  initveUrl:"https://onedex.club"
	}
}else{
	configURL = {
		  http_url: HOSTURLOBJECT.origin +'/api',
		  initveUrl:HOSTURLOBJECT.origin
	}
	
}
console.log('configURL',HOSTURLOBJECT);

export default configURL